<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1">
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field v-model="props.search" append-icon="search"
                        :label="$t('advanced_fulfillment_sent.search')" single-line hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"></v-text-field>
                </v-col>
                <!-- <v-spacer></v-spacer>  -->
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table class="px-0 my-2" no-results-text="No hay resultados" :headers="headers"
                                :items="props.items" :search="props.search" calculate-widths
                                :footer-props="{
                                    'items-per-page-text': this.$t('datatable.shown'),
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    pageText: '{0}-{1} ' + this.$t('datatable.of') + ' {2} ' + this.$t('datatable.results'),
                                    'show-current-page': true,
                                    'items-per-page-options': typeof props.rowsPP === 'undefined' ? [10, 25, 50, 100] : props.rowsPP
                                }" :page="1" :mobile-breakpoint="0"
                                item-key="id" v-model="selected">
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip top v-for="(action, i) of item.actions" :key="i">
                                        <template v-slot:activator="{ on }">
                                            <v-btn x-small v-if="!('link' in action)" icon
                                                @click="methodHandler(action.method, item.parameters)"
                                                :disabled="action.method === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color"
                                                    v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                            <v-btn x-small v-else icon text :to="action.link"
                                                :disabled="action.link === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color"
                                                    v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ action.name }}</span>
                                    </v-tooltip>
                                </template>
                                <v-data-footer :items-per-page-options="[]"></v-data-footer>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('advanced_fulfillment_sent.modal.delete') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('advanced_fulfillment_sent.modal.message') }}</h5>
                            </v-col>
                        </v-row>

                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('advanced_fulfillment_sent.no')
                                }}</v-btn>
                            <v-btn color="error" @click="deleteOrder">
                                {{ $t('advanced_fulfillment_sent.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_cod_pendings.order_details.header') }} {{
                                    this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>

                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{
                        $t('fulfillment_ptl_pendings.details')
                            }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.order_number")
                            }}</label> <label>{{ this.orderToShow.unique_order_number }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.date")
                            }}</label>
                        <label>{{ this.orderToShow.created_at }}</label>
                    </div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.shipping_service") }}</label> <label>{{
                                this.orderToShow.shipping_service
                            }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.shipping_service") }}</label> <label>{{
                                this.orderToShow.external_shipping_service }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.invoice")
                            }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.client") }}</label> <label>{{ this.orderToShow.client.name
                            }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.cod")
                            }}</label>
                        <label>{{ this.orderToShow.total }}</label>
                    </div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name
                            }}</label>
                    </div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state
                            }}</label>
                    </div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.municipality") }}</label> <label>{{
                                this.orderToShow.consignee.municipality
                            }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.neighborhood") }}</label> <label>{{
                                this.orderToShow.consignee.neighborhood
                            }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{
                                this.orderToShow.consignee.street }} {{
                                this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber
                            }}</label>
                    </div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{
                        $t("fulfillment_ptl_pendings.zip_code") }}</label> <label>{{
                                this.orderToShow.consignee.zipcode
                            }}</label></div>

                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{
                        $t('fulfillment_ptl_pendings.products') }}</label></div>
                    <!-- Shipments -->
                    <span v-if="orderToShow.shipment_product_detail != null">
                        <div v-for="(product, i) of orderToShow.shipment_product_detail" :key="i"
                            class="detail_content1"><label style="font-weight:bold">{{ product.product.sku }}</label>
                            <label>{{ product.quantity }}</label>
                        </div>
                    </span>
                    <!-- External Shipments -->
                    <span v-if="orderToShow.products != null">
                        <div v-for="(product, i) of orderToShow.products" :key="i" class="detail_content1"><label
                                style="font-weight:bold">{{ product.sku }}</label> <label>{{ product.quantity }}</label>
                        </div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDetail = false">{{
                                $t('fulfillments_cod_pendings.go_back')
                                }}</v-btn>
                        </div>
                    </v-card-text>
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalRestore" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('fulfillments_cod_in_process.restore_modal.restore') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_cod_in_process.restore_modal.message') }}</h5>
                            </v-col>
                        </v-row>

                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalRestore = false">{{
                                $t('fulfillments_cod_in_process.no')
                                }}</v-btn>
                            <v-btn color="error" @click="restoreOrder">
                                {{ $t('fulfillments_cod_in_process.yes_restore') }}
                            </v-btn>
                        </div>
                    </v-card-text>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { ptlShowOrderInfoUseCase } from '../../application/use_cases/ptl_show_order_info_use_case';
import { ptlSentUseCase } from '../../application/use_cases/ptl_sent_use_case';

export default {
    computed: {
        headers() {
            if (this.shipping_service != "otra") {
                return [
                    { text: this.$t('advanced_fulfillment_sent.order'), value: 'uniqueOrderNumber' },
                    { text: this.$t('advanced_fulfillment_sent.client'), value: 'client.name' },
                    { text: this.$t('advanced_fulfillment_sent.shipping_number'), value: 'shipmentNumber' },
                    // { text: this.$t('advanced_fulfillment_sent.pickup'), value: 'pickup' },
                    { text: this.$t('advanced_fulfillment_sent.status'), value: 'charge.lastStatus' },
                    { text: this.$t('advanced_fulfillment_sent.actions'), value: 'actions' },
                ];
            }
            else {
                return [
                    { text: this.$t('advanced_fulfillment_sent.order'), value: 'uniqueOrderNumber' },
                    { text: this.$t('advanced_fulfillment_sent.shipping_service'), value: 'externalShippingService' },
                    { text: this.$t('advanced_fulfillment_sent.client'), value: 'client.name' },
                    { text: this.$t('advanced_fulfillment_sent.shipping_number'), value: 'shipmentNumber' },
                    // { text: this.$t('advanced_fulfillment_sent.pickup'), value: 'pickup' },
                    { text: this.$t('advanced_fulfillment_sent.status'), value: 'charge.lastStatus' },
                    { text: this.$t('advanced_fulfillment_sent.actions'), value: 'actions' },
                ];
            }
        }
    },
    data() {
        return {
            shipping_service: this.$route.params.shipping_service,
            props: {
                search: '',
                items: [],
            },
            selected: [],
            modalDelete: false,
            modalDetail: false,
            modalRestore: false,
            orderToDelete: '',
            orderToShow: '',
            orderToRestore: '',
            controller_name: "advanced_fulfillment"
        }
    },
    mounted() {
        this.$store.state.module = "headers.advanced_fulfillment_" + this.shipping_service + "_sent";

        if (this.shipping_service == "eon") this.controller_name = "advanced_external_fulfillment";
        else this.controller_name = "advanced_fulfillment"

        this.index();
    },
    methods: {
        methodHandler(object, params) {
            this[object](params)
        },
        async index() {
            try {
                this.props.items = [];

                if (this.shipping_service != "eon") {
                    const result = await ptlSentUseCase(this.shipping_service, HttpShipmentRepository);
                    this.props.items = result;
                }
            }
            catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        async showDetails(order) {
            this.orderToShow = order;

            try {
                if (this.shipping_service == "eon") {
                    console.log("OKOOk")
                }
                else {
                    const result = await ptlShowOrderInfoUseCase(order.id, HttpShipmentRepository);
                    this.orderToShow = result;

                    this.modalDetail = true;
                }
            }
            catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        supplyOrder(order) {
            console.log(order.uniqueOrderNumber);
        },
        askRestore(order) {
            this.modalRestore = true;
            this.orderToRestore = order;
        },
        restoreOrder() {
            this.$store.state.loaderProps.visible = true;
            if (this.orderToRestore != '') {
                if (this.shipping_service == "eon") {
                    const lsToken = localStorage.getItem("access_token");
                    this.$http.put(this.$store.state.chronosApi + 'external_shipment/restore/' + this.orderToRestore.id, { headers: { Authorization: lsToken } })
                        .then((response) => {
                            if (response.status === 200) {
                                this.orderToRestore = '';
                                this.modalRestore = false;
                                this.snackbar = {
                                    visible: true,
                                    color: 'success2',
                                    text: this.$t('fulfillments_cod_sent.restored')
                                }
                                this.index();
                            }
                        }).catch((err) => {
                            console.log(err);
                        }).finally(() => {
                            this.$store.state.loaderProps.visible = false;
                        })
                }
                else {
                    const lsToken = localStorage.getItem("access_token");
                    this.$http.put(this.$store.state.chronosApi + 'shipment/restock/' + this.orderToRestore.id, {}, { headers: { Authorization: lsToken } })
                    .then((response) => {
                        if (response.data.code === 200) {
                            this.orderToRestore = '';
                            this.modalRestore = false;
                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('advanced_fulfillment_sent.restored')
                            }
                            this.index();
                        }
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        this.$store.state.loaderProps.visible = false;
                    })
                }
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: "error"
                }
            }
        },
        askDelete(order) {
            this.modalDelete = true;
            this.orderToDelete = order;
        },
        deleteOrder() {
            console.log(this.orderToDelete);
        },
        redirectEdit(order) {
            if (this.shipping_service != "eon") this.$router.push('/sent-shipments/prepaid/edit/' + order.id);
            else if (this.shipping_service == "eon") console.log("Comming soon")
        }
    },
    watch: {
        '$route.params.shipping_service': function () {
            location.reload();
        }
    }
}
</script>

<style lang="scss">
.marker1 {
    width: 100%;
    background-color: #c1d500;
    height: 12px;
    bottom: 0px;
}

.marker1-1 {
    width: 90%;
    margin: auto;
    background-color: #c1d500;
    height: 20px;
}

.detail_content {
    width: 90%;
    margin: auto;
    border-bottom: 1px solid black;
    padding: 0 .35em;
    display: flex;
    justify-content: space-between;
}

.detail_content1 {
    width: 90%;
    margin: auto;
    border-bottom: 1px solid black;
    padding: 0 .35em;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
}
</style>